import React, { useState, createContext, useMemo } from 'react';
import logComponent from '../common/logComponent';

// create context
const CardAverageResponseContext = createContext(null);
const timeRanges = [
  'Past 7 days',
  'Past 30 days'
];

// declare provider component
const CardAverageResponseProvider = ({ children }) => {

  const [averageResponse, setAverageResponse] = useState(null);
  const [averageResponseTimeRange, setAverageResponseTimeRange] = useState(timeRanges[0]);
  const [averageResponseLoading, setAverageResponseLoading] = useState(null);
  const [averageResponseError, setAverageResponseError] = useState(null);
  


  const setTheAverageResponse = (averageResponse) => {
    if (logComponent('CardAverageResponseContext')) { console.debug('CardAverageResponseContext setTheAverageResponse'); }
    let newAverageResponse = averageResponse ? { ...averageResponse } : null;
    setAverageResponse(newAverageResponse);
  }

  const setTheAverageResponseTimeRange = (timeRange) => {
    if (logComponent('CardAverageResponseContext')) { console.debug('CardAverageResponseContext setTheAverageResponseTimeRange'); }
    let newTimeRange = timeRange;
    setAverageResponseTimeRange(newTimeRange);
  }

  const setTheAverageResponseLoading = (averageResponseLoading) => {
    if (logComponent('CardAverageResponseContext')) { console.debug('CardAverageResponseContext setTheAverageResponseLoading'); }
    let newAverageResponseLoading = averageResponseLoading;
    setAverageResponseLoading(newAverageResponseLoading);
  }

  const setTheAverageResponseError = (averageResponseError) => {
    if (logComponent('CardAverageResponseContext')) { console.debug('CardAverageResponseContext setTheAverageResponseError'); }
    let newAverageResponseError = averageResponseError;
    setAverageResponseError(newAverageResponseError);
  }





  const cardState = useMemo(() => ({
    timeRanges,
    averageResponse,
    averageResponseTimeRange,
    averageResponseLoading,
    averageResponseError,
    setAverageResponse: setTheAverageResponse,
    setAverageResponseTimeRange: setTheAverageResponseTimeRange,
    setAverageResponseLoading: setTheAverageResponseLoading,
    setAverageResponseError: setTheAverageResponseError
  }), [
    timeRanges,
    averageResponse,
    averageResponseTimeRange,
    averageResponseLoading,
    averageResponseError
]);

  return (
    <CardAverageResponseContext.Provider value={ cardState }>
      {children}
    </CardAverageResponseContext.Provider>
  );
}

// export provider and context
export { CardAverageResponseContext, CardAverageResponseProvider };